<div class="container p-5">
    <h1 class="h3 mb-3 font-weight-normal">Email Verification</h1>
    <!-- SUCCESS -->
    <div *ngIf="activationSuccessful">
        <p>Your email address was verified successfully.</p>
        <div>
            <button class="btn btn-primary" routerLink="/login">Login</button>
        </div>
    </div>
    <!-- FAIL -->
    <div *ngIf="activationFailed">
        <p>Something went wrong. Please try again or <a routerLink="/contact">contact us</a>.</p>
    </div>
</div>